export interface BulkJobLite {
    job_id: number;
    job_status:
        | 'Error'
        | 'Success'
        | 'Processing'
        | 'Open'
        | 'Cancelled'
        | 'Aborted';
    account: { id: string; name: string };
    created_by: string;
    created_date: string;
    file_relative_path: string;
    files: BulkFile[];
    last_updated_by: string;
    last_update_date: string;
    type: string;
}

export interface BulkJob extends BulkJobLite {
    files: BulkFileDetail[];
}

export interface BulkFile {
    type: string;
    file_name: string;
    total_rows: number;
    errored_rows_count: number;
}

export interface BulkFileDetail extends BulkFile {
    errors: BulkFileError[];
    success_row_count: number;
    success_count: number;
    error_count: number;
    pending_count: number;
    success_events: BulkFileSuccess[];
}

export interface BulkFileError {
    row_number: number;
    event_code: string;
    row_errors: BulkFileRowError[];
}

export interface BulkFileRowError {
    error_code: number;
    error_msg: string;
    field_name: string;
    column_number: number;
    field_value: string;
    column_name: string;
    error_type: string;
}

export interface BulkFileSuccess {
    action: string;
    id: number;
    name: string;
    event_code: string;
}

export interface JobUploadResponse {
    jobId: number;
    fileName: string;
    fileId: string;
}

export interface EventUploadError {
    msg: string;
    row?: string;
    col?: string;
    colName?: string;
}

export enum EventUploadStatus {
    CREATED,
    STARTED,
    SUCCESS,
    FAILURE
}
export interface EventUpload {
    fileId: string;
    fileName: string;
    fileSize: number;
    fileExtension: string;
    jobId: number;
    uploadRatio: Number;
    errors: EventUploadError[];
    status: EventUploadStatus;
}
